<template>
  <div class="QuizSlider">
    <p class="Quiz_indic Quiz_indic_after">Positionnez le curseur</p>
    <div class="QuizSlider_wrapper">
      <div class="QuizSlider_choice" :class="{ 'QuizSlider_choice_selected': index == response }" v-for="(answer, index) in answers" :key="index" :style="{ marginRight: index == answers.length - 1 ? '0px' : null }">
        <div class="QuizSlider_choice_zone">
          <div class="QuizSlider_choice_zone_scare"></div>
          <div class="QuizSlider_choice_zone_sep" v-if="index < answers.length - 1"></div>
        </div>
        <div class="QuizSlider_choice_label" :class="{ 'QuizSlider_choice_label_hide': secondIsSelected, 'QuizSlider_choice_label_second': (index & 1 == 1), 'QuizSlider_choice_label_selected': response == String(index) }">{{ answer.label }}</div>
      </div>
      <input @change="onChange" @touchmove="onChange" @blur="isSelected = false" class="QuizSlider_input" :class="{ 'QuizSlider_input_selected': isSelected}" type="range" name="response" min="0" :max="answers.length - 1" v-model="response" ref="input"/>
    </div>
  </div>
</template>

<script>
  // let ie = navigator.userAgent.indexOf('MSIE ') > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)
  //     if(!ie)
  //     {
  //       import('rangetouch')
  //       .then(module => {

  //         console.log('rangeTouch', module)
  //         // module.setup('input[type="range"]');
  //         module.loadPageInto()
  //         // this.range = new something.setup('input[type="range"]');
  //       });
  //     }
  export default {
    name: "QuizSlider",
    props: [ 'answers' ],
    data() {
      return {
        response: '',
        range: null,
        isSelected: false,
        secondIsSelected: false,
      }
    },
    watch: {
      response()
      {
        if(this.response == 1 || this.response == 3){
          this.secondIsSelected = true
        }else{
          this.secondIsSelected = false
        }
      }
    },
    methods: {
      onChange()
      {
        this.isSelected = true
        this.$emit('fieldOk', { id: this.answers[this.response].id })
      }
    },
    created()
    {
      this.response = (this.answers.length - 1) / 2
    },
    beforeDestroy()
    {
      // if(this.range)
        this.range.destroy()
    },
    mounted()
    {
      this.range = new RangeTouch('input[type="range"]');
      // this.$emit('fieldOk', { id: this.answers[this.response].id })
    }
  }
</script>

<style lang="stylus" scoped>
.QuizSlider

  position relative
  margin auto
  margin-bottom 25px
  margin-top 120px
  transition-delay 0.2s

  @media $medium

    margin-top 0px

  p

    margin-bottom 20px
    margin-top 0px

  &_wrapper

    display inline-flex
    flex-direction row
    position relative
    align-items stretch
    justify-content center

  &_input

    position absolute
    top 0px
    left 0px
    width 100%
    height 100%
    cursor ew-resize
    z-index 2 
    appearance: none;
    background transparent
    border 0px
    border-radius 0px
    box-shadow 0px

  &_choice

    position relative
    margin-right 25px
    z-index 0

    &_zone

      position relative

      &_scare

        transform: rotate(-45deg);
        background: white;
        border: 2px solid $n2;
        border-radius: 5px;
        height 25px
        width 25px
        box-sizing border-box
        position relative
      
      &_sep

        width 25px
        z-index -1
        left 100%
        position absolute
        top 50%
        transform translateY(-50%)
        height 2px
        background-color $n2

    &_label

      font-family $f-title
      font-size: 10px;
      color: $s1;
      letter-spacing: 0;
      text-align: center;
      line-height: 14px;
      position absolute
      top calc(100% + 10px)
      transform translateX(-50%)
      left 50%
      transition opacity 0.1s linear
      text-align center
      width 65px

      &_hide

        opacity 0

      &_second

        opacity 0

      &_selected

        opacity 1

    &_selected

      .QuizSlider_choice_label

        color $blue
        font-size 14px
        width 90px

  input[type="range"] {
    -webkit-tap-highlight-color: transparent;
  }
  input[type=range]::-webkit-slider-runnable-track {
    width: 100%;
    height: 0px;
    box-shadow: 0px
    background: transparent;
    border-radius: 0px;
    border: 0px;
  }
  input[type=range]::-webkit-slider-thumb {
    transform: scale(1.33) rotate(-45deg);
    border: 1px solid $n2;
    border-radius: 5px;
    height 25px
    width 25px
    box-sizing border-box
    position relative
    appearance: none;
    top -15px
    left -2px
    background: white;
    background-image url(../../public/static/images/slider.png)
    background-position center
    background-size 48%
    background-repeat no-repeat
    box-shadow: 0 2px 10px 0 rgba(0,0,0,0.06);
  }
  input[type=range].QuizSlider_input_selected::-webkit-slider-thumb {
    background: $blue;
    background-image url(../../public/static/images/slider-focus.png)
    background-position center
    background-size 48%
    background-repeat no-repeat
  }
  
  input[type=range]:focus::-webkit-slider-runnable-track {
    background: transparent;
  }
  input[type=range]::-moz-range-track {
    width: 100%;
    height: 0px;
    box-shadow: 0px;
    background: transparent;
    border-radius: 0px;
    border: 0px;
  }
  input[type=range]::-moz-range-thumb {
    transform: scale(1.33) rotate(-45deg);
    background: white;
    border: 1px solid $n2;
    border-radius: 5px;
    height 25px
    width 25px
    box-sizing border-box
    position relative
    appearance: none;
    top -15px
    left -2px
    background-image url(../../public/static/images/slider.png)
    background-position center
    background-size 48%
    background-repeat no-repeat
    box-shadow: 0 2px 10px 0 rgba(0,0,0,0.06);
  }
  input[type=range]::-ms-track {
    width: 100%;
    height: 0px;
    background: transparent;
    border-color: transparent;
    color: transparent;
  }
  input[type=range]::-ms-fill-lower {
    display none
  }
  input[type=range]::-ms-fill-upper {
    display none
  }
  input[type=range]::-ms-thumb {
    transform: scale(1.33) rotate(-45deg);
    background: white;
    border: 1px solid $n2;
    border-radius: 5px;
    height 25px
    width 25px
    box-sizing border-box
    position relative
    appearance: none;
    top -15px
    left -2px
    background-image url(../../public/static/images/slider.png)
    background-position center
    background-size 48%
    background-repeat no-repeat
    box-shadow: 0 2px 10px 0 rgba(0,0,0,0.06);
  }
  input[type=range]:focus::-ms-fill-lower {
    display none
  }
  input[type=range]:focus::-ms-fill-upper {
    display none
  }
</style>